import { atom } from 'recoil'
import { IProtectionDayResponse, IRoomInsideDefence } from './protection.types'

interface IProtectionDays {
  items: IProtectionDayResponse[]
}

export const protectionAtom = atom<IProtectionDays>({
  key: 'protectionDays',
  default: {
    items: [],
  },
})

export const activeRoomAtom = atom<IRoomInsideDefence | null>({
  key: 'activeRoom',
  default: null,
})
